import { connectorSubscriptions } from "../../apiService/blustreamApi";

export const getSubscription = () => connectorSubscriptions.get();

export const createSubscription = (name, apiKey) =>
  connectorSubscriptions.create({ name, api_key: apiKey });

export const updateSubscription = (updates) => connectorSubscriptions.update(updates);

export const deleteSubscription = () => connectorSubscriptions.remove();

export const getSubscriptionSummary = () => connectorSubscriptions.getSummary();

export const rotateWebhookSecret = () => connectorSubscriptions.rotateWebhookSecret();

export const getWebhookSecret = () => connectorSubscriptions.getWebhookSecret();

// Fetches Klaviyo's install URL from our authenticated API, then the caller navigates
// the browser to klaviyo.com. Navigating to our own endpoint cannot work: a top-level
// navigation carries no Authorization header, so the gateway rejects it before our
// code runs. The tenant comes from the session, so no customer id is sent.
export const getOAuthAuthorizeUrl = async () => {
  const response = await connectorSubscriptions.getOAuthUrl();
  return response.authorize_url;
};
